// utils/ExportToExcel.js
import * as XLSX from "xlsx";

export const exportToExcel = (jsonData, reportType) => {
    let processedData = [];
    switch (reportType?.ReportType) {
        case "issued_etd_reports":
            processedData = jsonData.map((x) => ({
                FullName: x.FullName,
                ETDNumber: x.ETDNumber,
                PaymentControlNo: x.PaymentControlNo,
                IssuedDate: x.IssuedDate,
                ExpiredDate: x.ExpiredDate,
                IssuedAt: x.IssuedAt,
                ApplicationID: x.ApplicationID,

            }));
            break;

        case "defined_reports":
            processedData = jsonData.map((x) => ({
                FullName: x.FullName,
                ETDNumber: x.ETDNumber,
                PaymentControlNo: x.PaymentControlNo,
                IssuedDate: x.IssuedDate,
                ExpiredDate: x.ExpiredDate,
                IssuedAt: x.IssuedAt,
                ApplicationID: x.ApplicationID,

            }));
            break;
        case "payments_report":
            processedData = jsonData.map((x) => ({
                ApplicationID: x.ApplicationID,
                FullName: x.FullName,
                PaymentControlNo: x.PaymentControlNo,
                Amount: x.Amount,
                ReceiptDate: x.ReceiptDate

            }));
            break;
        case "get_etd_reports_by_doctype":
            processedData = jsonData.map((x) => ({
                ApplicationID: x.ApplicationID,
                FullName: x.FullName,
                ETDNumber: x.ETDNumber,
                IssuedAt: x.IssuedAt,
                PaymentControlNo: x.PaymentControlNo,
                IssuedDate: x.IssuedDate,
                ExpiredDate: x.ExpiredDate,

            }));
            break;

              case "get_etd_reports_by_admin":
            processedData = jsonData.map((x) => ({
                ApplicationID: x.ApplicationID,
                FullName: x.FullName,
                ETDNumber: x.ETDNumber,
                IssuedAt: x.IssuedAt,
                PaymentControlNo: x.PaymentControlNo,
                IssuedDate: x.IssuedDate,
                ExpiredDate: x.ExpiredDate,

            }));
            break;

        default:
            console.warn("Unknown report type");
    }

    const worksheet = XLSX.utils.json_to_sheet(processedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
    XLSX.writeFile(workbook, "report.xlsx");
};
